module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/readable-stream/passthrough.js
// module id = 572
// module chunks = 0 3 5